import { alpha, SxProps, useTheme } from "@mui/material";
import { StyleguideSavioColors } from "../../../configuration/themeSettings";

export const useClasses = () => {
    const theme = useTheme();

    const classes = {
        listResults: {
            width: 'auto'
        } as SxProps,

        listItem: {
            borderBottomStyle: 'solid',
            borderBottomWidth: '1px',
            borderBottomColor: theme.palette.grey, //   '1px solid lightgrey !important'
            paddingTop: "0px",
            paddingBottom: "0px",
            cursor: "pointer",
            "&:hover": { backgroundColor: alpha(theme.palette.footer.main, .2) },
            "& p": { textTransform: "uppercase" },
            "& disabled": { color: "red" }
        } as SxProps,

        listItemTextSecondary: {
            overflow: 'hidden',
            whiteSpace: 'wrap',
            display: "flex",
            maxWidth: 500,
            textOverflow: 'ellipsis',
            color: StyleguideSavioColors.text.black,
        } as SxProps,
    }

    return classes;
}